// eslint-disable-next-line no-unused-vars
import { LIMPAR_TIPOS_VEICULO, SELECIONAR_TIPOS_VEICULO } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarRota (state = [], action = initialState) {
  switch (action.type) {
    case SELECIONAR_TIPOS_VEICULO: {
      return action.payload;
    }
    case LIMPAR_TIPOS_VEICULO:
      return []

    default: {
      return state
    }
  }
}
